import { WorkspaceSubscriptionPage } from "./WorkspaceSubscriptionPage";

export default WorkspaceSubscriptionPage;
